import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../helper/URLHelper';
import CrmKanbanBoard from './index.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.CRM_V2,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    component: CrmKanbanBoard,
    name: 'crm_kanban',
    meta,
  },
];
